/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-24 10:26:19
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-16 14:36:08
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorShoppingCartPage/tools.ts
 */
import _ from 'lodash';
import { errCodesMap } from 'src/error/code';
import {
  EnumCollapseId,
  generateDefaultFeaturedProducts,
  generateDefaultButtonStyle,
  generateDefaultEmptyStateSetting,
  generateDefaultNoticeBoard,
} from 'src/pages/SalesChannelContentEditor/SalesChannelEditorShoppingCartPage/common';
import { convertSpecificError } from 'src/constrains/SalesChannelPreviewPageComponents/tools';
import {
  generateCollapseOpen,
  generateCollapseErrorMsgDisplay,
} from 'src/constrains/SalesChannelPreviewPageComponents/tools';
import { generateCollapse } from 'src/constrains/SalesChannelPreviewPageComponents/tools';
import { reduxUpdatedStatusControl } from 'src/tools/helper';

export const fixedCollapse = [
  EnumCollapseId.featuredProducts,
  EnumCollapseId.emptyStateSetting,
  EnumCollapseId.buttonStyle,
  EnumCollapseId.noticeBoard,
];

export const errKey = {
  emptyStateSettingTextErr: 'emptyStateSettingTextErr',
  emptyStateSettingImageErr: 'emptyStateSettingImageErr',
  buttonTextTextErr: 'buttonTextTextErr',
  noticeBoardTitleErr: 'noticeBoardTitleError',
  noticeBoardContentErr: 'noticeBoardContentErr',
};

export const defaultCollapse = (display?) => {
  return generateCollapse(fixedCollapse, display);
};

export const validateEmptyStateSetting = (emptyState, isPrimary?) => {
  const { image, text } = emptyState || {};
  const specificErr = {
    [errKey.emptyStateSettingImageErr]: [],
    [errKey.emptyStateSettingTextErr]: [],
  };
  if (!text) {
    specificErr[errKey.emptyStateSettingTextErr].push(errCodesMap[999999]);
  }
  if (!(image || {}).uuid) {
    specificErr[errKey.emptyStateSettingImageErr].push(errCodesMap[199221]);
  }
  return {
    hasError: convertSpecificError(specificErr).length > 0,
    specificError: specificErr,
    generalError: [],
  };
};

export const validateButtonText = (buttonText, isPrimary?) => {
  const specificErr = {
    [errKey.buttonTextTextErr]: [],
  };
  const { text } = buttonText || {};
  if (!text) {
    specificErr[errKey.buttonTextTextErr].push(errCodesMap[999999]);
  }
  return {
    hasError: convertSpecificError(specificErr).length > 0,
    specificError: specificErr,
    generalError: [],
  };
};

export const validateNoticeBorder = (noticeBoard) => {
  // const err = [];
  const { enabled, title, content } = noticeBoard || {};

  const generalError = [];
  const specificErr = {};
  if (!enabled) {
    return {
      hasError: false,
      specificError: specificErr,
      generalError,
    };
  } else {
    specificErr['titleError'] = [];
    specificErr['contentError'] = [];
    if (!title) {
      specificErr['titleError'].push(errCodesMap[999994]);
    }
    if (!content) {
      specificErr['contentError'].push(errCodesMap[999993]);
    }

    return {
      hasError: convertSpecificError(specificErr).length > 0,
      specificError: specificErr,
      generalError,
    };
  }
};

export const convertDataFromServerToRedux = (data) => {
  const _emptyStateSetting = generateDefaultEmptyStateSetting();
  const _buttonStyle = generateDefaultButtonStyle();
  const _featuredProducts = generateDefaultFeaturedProducts();
  const _noticeBoard = generateDefaultNoticeBoard();
  const {
    hasError,
    buttonStyle = {},
    featuredProducts = {},
    contentUuid,
    salesChannelContent,
    salesChannelName,
    uuid,
    modifiedDate,
    createdDate,
    emptyStateSetting = {},
    noticeBoard,
  } = data;

  const _isNew = !uuid;

  const collapseOpen = generateCollapseOpen(fixedCollapse);
  const collapseErrorMsgDisplay = generateCollapseErrorMsgDisplay(
    fixedCollapse,
    !_isNew,
  );

  if (hasError) {
    let flag = false;
    const _emptyStateSettingErr = validateEmptyStateSetting(emptyStateSetting);
    if (_emptyStateSettingErr.hasError) {
      collapseErrorMsgDisplay[EnumCollapseId.emptyStateSetting].hasError = true;
      //collapseErrorMsgDisplay[EnumCollapseId.emptyStateSetting].display = true;
      if (!flag) {
        flag = true;
        collapseOpen[EnumCollapseId.emptyStateSetting] = true;
      }
    }
    const _buttonStyleErr = validateButtonText(buttonStyle);
    if (_buttonStyleErr.hasError) {
      if (!flag) {
        flag = true;
        collapseOpen[EnumCollapseId.buttonStyle] = true;
      }
      collapseErrorMsgDisplay[EnumCollapseId.buttonStyle].hasError = true;
    }
    const { hasError: _noticeBoardErr } = validateNoticeBorder(noticeBoard);
    if (_noticeBoardErr) {
      if (!flag) {
        flag = true;
        collapseOpen[EnumCollapseId.noticeBoard] = true;
      }
      collapseErrorMsgDisplay[EnumCollapseId.noticeBoard].hasError = true;
    }
  }

  return {
    hasError,
    collapseErrorMsgDisplay,
    collapseOpen,
    buttonStyle: buttonStyle || _buttonStyle,
    featuredProducts: featuredProducts || _featuredProducts,
    contentUuid,
    salesChannelContent: salesChannelContent || {},
    salesChannelName,
    uuid,
    modifiedDate,
    createdDate,
    emptyStateSetting: emptyStateSetting || _emptyStateSetting,
    noticeBoard: noticeBoard || _noticeBoard,
    ...reduxUpdatedStatusControl,
  };
};

export const convertDataFromReduxToServer = (state) => {
  const _state = _.cloneDeep(state);
  const {
    contentUuid,
    uuid,
    buttonStyle,
    featuredProducts,
    emptyStateSetting,
    noticeBoard,
  } = _state;

  let _noticeBoard = noticeBoard || {};
  const { enabled } = _noticeBoard;
  if (!enabled) {
    _noticeBoard = { enabled: false };
  }

  return {
    contentUuid,
    uuid,
    buttonStyle,
    featuredProducts,
    emptyStateSetting,
    noticeBoard: _noticeBoard,
  };
};
